import axios from 'axios';

import { Category, Subcategory } from '../types/categories';

const API_URL = import.meta.env.VITE_API_URL || 'http://0.0.0.0:8055';

export const fetchCategoriesAndCourses = async (): Promise<{
  categories: Category[];
  subcategories: Subcategory[];
}> => {
  try {
    const [categoriesResponse, subcategoriesResponse] = await Promise.all([
      axios.get(`${API_URL}/items/categories`, {
        params: {
          fields: [
            'id',
            'translations.*',
            'slug',
            'details.categories_details_id.*',
            'details.categories_details_id.translations.*',
            'details.categories_details_id.artists.artist_info_id.slug',
            'details.categories_details_id.artists.artist_info_id.translations.*',
            "details.categories_details_id.category_page.about_project_page_id.slug"
          ],
        },
      }),
      axios.get(`${API_URL}/items/subcategories`, {
        params: {
          fields: ['id', 'translations.*', 'categories.categories_id'],
        },
      }),
    ]);

    return {
      categories: categoriesResponse.data.data,
      subcategories: subcategoriesResponse.data.data,
    };
  } catch (error) {
    console.error('Error fetching categories and subcategories:', error);
    throw error;
  }
};
